import ArrowLeft from '../../assets/svg/arrow-left.svg';
import ArrowRight from '../../assets/svg/arrow-right.svg';
import "../table/table.css";

type Props = {
  currentPage: any,
  totalCount: any,
  pageSize: any,
  onPageChange: any,
};

export default function TablePagination({
  currentPage,
  totalCount,
  pageSize,
  onPageChange,
}: Props) {
  const totalPages = Math.ceil(totalCount / pageSize);

  // Handle page change
  const handlePageChange = (pageNumber: number) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      onPageChange(pageNumber);
    }
  };

  // Pagination Numbers with Ellipses
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5; // Number of page numbers to show at once

    if (totalPages <= maxPageNumbersToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(renderPageButton(i));
      }
    } else {
      const startPage = Math.max(currentPage - 2, 1);
      const endPage = Math.min(currentPage + 2, totalPages);

      if (startPage > 1) {
        pageNumbers.push(renderPageButton(1));
        if (startPage > 2) {
          pageNumbers.push(<span key="start-ellipsis">...</span>);
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(renderPageButton(i));
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push(<span key="end-ellipsis">...</span>);
        }
        pageNumbers.push(renderPageButton(totalPages));
      }
    }

    return pageNumbers;
  };

  // Helper function to render a page button
  const renderPageButton = (pageNumber: number) => (
    <button
      key={pageNumber}
      onClick={() => handlePageChange(pageNumber)}
      disabled={currentPage === pageNumber}
      className={`${currentPage === pageNumber ? 'itemButtonActive' : 'itemButton'}`}
    >
      {pageNumber}
    </button>
  );

  return (
    <div className="py-4 flex tableFooter items-center justify-center">
      <div className="pagination-count flex items-center justify-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
          className='bg-white border border-gray-300 shadow-md px-[9px] py-[8px] rounded text-sm leading-inherit mr-1'
        >
          <img src={ArrowLeft} alt=''/>
        </button>

        {renderPageNumbers()}

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
          className='bg-white border border-gray-300 shadow-md px-[8px] py-[8px] rounded text-sm leading-inherit ml-1'
        >
          <img src={ArrowRight} className="h-3 w-3" alt=''/>

        </button>
      </div>
    </div>
  );
}
